var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m16.25 4.583-.516 8.354c-.132 2.135-.198 3.202-.733 3.97-.265.379-.605.699-1 .94-.8.486-1.868.486-4.007.486-2.141 0-3.212 0-4.011-.488a3.3 3.3 0 0 1-1-.941c-.536-.769-.6-1.838-.73-3.975L3.75 4.583"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2.5 4.584h15m-4.12 0-.57-1.174c-.377-.78-.566-1.17-.892-1.412a2 2 0 0 0-.229-.144c-.36-.187-.794-.187-1.66-.187-.888 0-1.332 0-1.7.195a2 2 0 0 0-.231.15c-.33.252-.514.656-.882 1.464L6.71 4.584"
  })));
};
export default SvgTrash;